import * as React from 'react';
import { WithNamespaces, withNamespaces } from 'react-i18next';

const NotFoundRaw: React.SFC<WithNamespaces> = ({ t }) => (
  <h2>{t('error.notFound')}</h2>
)

export const NotFound = withNamespaces()(NotFoundRaw)
